import Handlebars from 'handlebars';

Handlebars.registerHelper('if_eq', function(a, b, opts) {
    if (a == b) {
        return opts.fn(this);
    } else {
        return opts.inverse(this);
    }
});


function createMarkup(template = "", data = {}) {


    let html = "";
    if (template != "") {
        const _template = Handlebars.compile(template);        
        html = _template(data);
    }

    return { __html: html }
};
export default createMarkup;
